module.exports = __webpack_public_path__ + "2c2a67274df52e55eb283dd3d332e73f.pdf";